module.exports = __webpack_public_path__ + "static/media/CRUD.edb43d33.svg";